import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getDfiAnnualReports, QueryDefaults } from 'api';
import { DfiReportsResponse } from 'types';

export const useDfiAnnualReports = (): UseQueryResult<DfiReportsResponse> =>
  useQuery([API_QUERY_KEYS.getDfiAnnualReports], getDfiAnnualReports, QueryDefaults);
